import JetpackPartnerSection from './jetpack-partner-section'

export default JetpackPartnerSection
